import React from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { validateRequired } from "@qgiv/core-validation";
import { FormikField } from "@qgiv/core-donor";
import { selectAllFields } from "../../redux/slices/fieldsSlice";

const ConnectedField = (props) => {
    const fields = useSelector(selectAllFields);
    const { id } = props;

    const field = fields.find((_field) => _field.id === id);

    const { required = false } = field;

    const formikFieldProps = {
        ...props,
        validate: required ? validateRequired : undefined,
        descText: !required ? "Optional" : "",
        ariaRequired: required ? "true" : "false",
    };

    return <FormikField {...formikFieldProps} />;
};

ConnectedField.propTypes = {
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

export default ConnectedField;
